export const selectPerPage = ({ general }) => general.settings.perPage;
export const selectUserId = ({ user }) => user.user.id;
export const selectTeamEvents = ({ calendar }) => calendar.teamEvents;
